import React, { Component } from 'react';
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import ReactHtmlParser from 'react-html-parser';
import {BASE} from '../api/api'
import cachios from 'cachios';
import {Link} from 'react-router-dom'
import { List } from 'react-content-loader'
import {getName} from 'country-list'


class InstituteDesc extends Component {
    constructor(props) {  
        console.log(props,"props")
        super(props);
        this.state={
          nid:props.match.params.nid,
          type:props.match.params.type,
          loginred:'/login?redir='+props.location.pathname

        }
      }
      checklogin(){
        let dt = localStorage.getItem('token')
        if (!dt || dt == null) {
         
          window.location.href = this.state.loginred
        }
        else
          return true
      }
      topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    
      signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        // window.location.href = '/'
    
      }
    
    
      refreshexp(){
        let s = new Date();
        s.setSeconds(s.getSeconds()+1800);
        localStorage.setItem('expiryref', s)
      }
    
    
      checkexpiry(){
        if(localStorage.getItem('expiryref')){
          let expref=Date.parse(localStorage.getItem('expiryref'))
          let s = new Date();
          if(s>expref){
              this.signout()
          }
          else{
            this.refreshexp()
          }
          
        }
        else{
          this.signout()  
      }
      }
    
    
      componentWillMount() {
        if(localStorage.getItem('token'))
            this.checkexpiry()
        this.topFunction()
        if(this.checklogin()){
        
          cachios.get(BASE+'jsonapi/node/institutions?filter[titleFilter][condition][path]=field_institution_type.name&filter[titleFilter][condition][value]='+this.state.type+'&filter[drupal_internal__nid]='+this.state.nid, {
            ttl: 500 /* seconds */,
            })
            .then((data) => {
              console.log(data,"high")
                this.setState({
                    companies: data.data.data[0].attributes
                })
            })
        
        }
      }

  render() {
    console.log('xxx',this.state.type)
    if(this.checklogin())
    return (
        <div className='institutions'>
          <Header/>
        <body className="wiki" >
    {this.state.companies?
    <div className="main-content">
      <div id="instdescid" className="container">
      <div className="crumbs "><Link to='/'>Home</Link> / <Link to='/financial_institution'>Financial Institutions in Qatar</Link> / {this.props.match.params.nid}</div>
        <div className="row">
          <div className="node-wiki node">
            
            <div style={{width:'100%' , minHeight:'61.5vh'}} className="group-middle">
              <div className="field-name-title">

                <div className='heading'>{this.state.companies?this.state.companies.title:''}</div>
                  <div className="field-name-metadata-books">
                    <div className="field-item even">
                      <div className="view-wiki">
                          <ul>
                              {this.state.companies.field_phone?<li className="first">
                                <div className="field-name-field-title">Phone</div>
                                <div className="field-name-field-body">{this.state.companies.field_phone}</div>
                              </li>:''}
                              {this.state.companies.field_website?<li>
                                <div className="field-name-field-title">Website</div>
                                <div className="field-name-field-body webaddr"><a target="_blank" rel="noopener noreferrer"  href={this.state.companies.field_website.uri}>{this.state.companies.field_website.uri}</a></div>
                              </li>:''}
                              {this.state.companies.field_country?<li className="first">
                                <div className="field-name-field-title">Country</div>
                                <div className="field-name-field-body">{getName(this.state.companies.field_country)}</div>
                              </li>:''}
                              {this.state.companies.field_place?<li className="first">
                                <div className="field-name-field-title">Place</div>
                                <div className="field-name-field-body">{this.state.companies.field_place}</div>
                              </li>:''}
                              {this.state.companies.field_arabic_name?<li className="first">
                                <div className="field-name-field-title">Arabic name</div>
                                <div className="field-name-field-body">{this.state.companies.field_arabic_name}</div>
                              </li>:''}
                          </ul>
                      </div>
                    </div>
                  </div>
              </div>
              
              <div className="field field-name-body field-type-text-with-summary field-label-hidden">
                <div className="field-items">
                  <div className="field-item even" property="content:encoded">
                  {ReactHtmlParser(this.state.companies.body.value)}
                  </div>
                </div>
              </div>

            </div>
            
          </div>
        </div>
      </div>
    </div>:<List/>}
    
    
    
  </body>


        <div><Footer/></div>
        </div>
    )
}
}


export default InstituteDesc;
